import { useState } from 'react';
import { defaultSettings } from '../konstanter/siteConfig';

function mergeSettings(settings) {
  return {
    ...defaultSettings,
    ...settings,
  };
}

export function useAdminSettingsForm() {
  const [settingsForm, setSettingsForm] = useState(defaultSettings);

  const applySettings = (settings) => {
    setSettingsForm(mergeSettings(settings));
  };

  return {
    applySettings,
    settingsForm,
    setSettingsForm,
  };
}